import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDigitalPaymentFunctional = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2982_2895)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.89989 0.859375C2.57532 0.859375 -0.120117 3.5548 -0.120117 6.87937V14.9194V49.0394C-0.120117 52.3639 2.57532 55.0594 5.89989 55.0594H21.9599C23.0645 55.0594 23.9599 54.1639 23.9599 53.0594C23.9599 51.9548 23.0645 51.0594 21.9599 51.0594H5.89989C4.78446 51.0594 3.87988 50.1548 3.87988 49.0394V16.9194H56.0999V29.0194C56.0999 30.1239 56.9953 31.0194 58.0999 31.0194C59.2045 31.0194 60.0999 30.1239 60.0999 29.0194V14.9194V6.87937C60.0999 3.5548 57.4045 0.859375 54.0799 0.859375H5.89989ZM56.0999 12.9194V6.87937C56.0999 5.76395 55.1953 4.85938 54.0799 4.85938H5.89989C4.78445 4.85938 3.87988 5.76395 3.87988 6.87937V12.9194H56.0999Z",
				fill: "#202227"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M31.9995 41.0395C31.9995 39.9241 32.9041 39.0195 34.0195 39.0195H58.1195C59.2349 39.0195 60.1395 39.9241 60.1395 41.0395V43.0596H31.9795V41.3235C31.9927 41.2307 31.9995 41.1359 31.9995 41.0395ZM31.9795 47.0596V57.0995C31.9795 58.215 32.8841 59.1195 33.9995 59.1195H58.1195C59.2349 59.1195 60.1395 58.215 60.1395 57.0995V47.0596H31.9795ZM27.9795 41.0395C27.9795 40.9216 27.9897 40.8061 28.0093 40.6938C28.1884 37.5301 30.811 35.0195 34.0195 35.0195H58.1195C61.4441 35.0195 64.1395 37.7149 64.1395 41.0395V57.0995C64.1395 60.4241 61.4441 63.1195 58.1195 63.1195H33.9995C30.6749 63.1195 27.9795 60.4241 27.9795 57.0995V41.0395Z",
				fill: "#202227"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M48.0596 53.0996C48.0596 51.995 48.955 51.0996 50.0596 51.0996H54.0796C55.1841 51.0996 56.0796 51.995 56.0796 53.0996C56.0796 54.2042 55.1841 55.0996 54.0796 55.0996H50.0596C48.955 55.0996 48.0596 54.2042 48.0596 53.0996Z",
				fill: "#202227"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.5 32.02H14.5C12 32.02 12 30.8 12 30.26C12 29.72 12 28.5 14.5 28.5H21C22.1 28.5 23 27.6 23 26.5C23 25.4 22.1 24.5 21 24.5H18V24C18 22.9 17.1 22 16 22C14.9 22 14 22.9 14 24V24.54C10.34 24.72 8 26.92 8 30.26C8 33.6 10.56 36.02 14.5 36.02H17.5C20 36.02 20 37.24 20 37.78C20 38.32 20 39.54 17.5 39.54H11C9.9 39.54 9 40.44 9 41.54C9 42.64 9.9 43.54 11 43.54H14V44.04C14 45.14 14.9 46.04 16 46.04C17.1 46.04 18 45.14 18 44.04V43.5C21.66 43.32 24 41.12 24 37.78C24 34.44 21.44 32.02 17.5 32.02Z",
				fill: "#202227"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2982_2895",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			fill: "white"
		})
	}) })]
});
export default SvgDigitalPaymentFunctional;
